// extracted by mini-css-extract-plugin
export var compactFilters = "_d6-4";
export var detailImage = "_d6-1";
export var dropdownContainer = "_d6-2";
export var imageContainer = "_d6-0";
export var selectedCard = "_d6-3";